import React from 'react'
import { any, async, fromJSX, onlyIf, Updater, Widget } from 'widgets-for-react'
import { Department, Centrum } from '../../../cmsPageState'
import { WaitingTimesBlock } from '../../blocksState'
import { WaitingTimesBlockLayout } from './waitingTimesBlockLayout'
import {
  ConsultationOverview,
  ConsultationTimes,
  WaitingFor,
  WaitingTimesBlockState,
  waitingTimesBlockStateUpdaters,
  WaitingTimesByKind,
} from './waitingTimesBlockState'

/*
Current order of elements for this block:
1. Prefix
2. Consultation overview
3. Consultation times
4. Waiting times by deparment
5. Suffix
*/

export const waitingTimesBlockWidget = (block: WaitingTimesBlock, forPage?: WaitingFor): Widget<Updater<WaitingTimesBlockState>> =>
  any<Updater<WaitingTimesBlockState>>([
    async<Department | Centrum>(block.waitingTimesBlockState.forState).map(
      waitingTimesBlockStateUpdaters.updateDepartmentState
    ),

    async<ConsultationOverview>(block.waitingTimesBlockState.consultationsOverviewState).map(
      waitingTimesBlockStateUpdaters.updateConsultationOverview
    ),

    onlyIf(forPage != null, async<ConsultationTimes>(block.waitingTimesBlockState.consultationTimesState)).map(
      waitingTimesBlockStateUpdaters.updateConsultationTimes
    ),

    onlyIf(forPage != null, async<WaitingTimesByKind>(block.waitingTimesBlockState.waitingTimesByDepartmentState)).map(
      waitingTimesBlockStateUpdaters.updateWaitingTimesByDepartment
    ),
    
    fromJSX(() => (
      <>
        <WaitingTimesBlockLayout.Prefix 
          text={forPage ? block.prefixDepartment : block.prefixGeneral}  
          spoedafspraak={block.spoedafspraak}
        />

        {/* Consultation Overview */}
        {block.waitingTimesBlockState.consultationsOverviewState.kind == 'loaded' && (
          <WaitingTimesBlockLayout.ConsultationOverview 
            overview={block.waitingTimesBlockState.consultationsOverviewState.value} 
          />
        )}

        {/* Consultation Times */}
        {forPage && block.waitingTimesBlockState.consultationTimesState.kind == 'loaded' && (
          <WaitingTimesBlockLayout.ConsultationTimes
            linkElement={
              block.waitingTimesBlockState.waitingTimesByDepartmentState.kind !== 'loaded' &&
              block.waitingTimesBlockState.forState.kind === 'loaded' ? (
                <WaitingTimesBlockLayout.ParentLink parent={block.waitingTimesBlockState.forState.value}/>
              ) : undefined
            }
            consultations={block.waitingTimesBlockState.consultationTimesState.value}
          />
        )}

        {/* Waiting times by department */}
        {forPage && block.waitingTimesBlockState.waitingTimesByDepartmentState.kind == 'loaded' && (
          <WaitingTimesBlockLayout.WaitingTimesByDepartment
            linkElement={
              block.waitingTimesBlockState.forState.kind === 'loaded' ? (
                <WaitingTimesBlockLayout.ParentLink parent={block.waitingTimesBlockState.forState.value}/>
              ) : undefined
            }
            waitingTimes={block.waitingTimesBlockState.waitingTimesByDepartmentState.value}
          />
        )}
        
        <WaitingTimesBlockLayout.Suffix 
          text={forPage ? block.suffixDepartment : block.suffixGeneral}
        />
      </>
    ))  

  ])
